import ProviderRatesService from "@/services/ProviderRatesService";

const INITIAL_PAGINATION = {
  pageIndex: 0,
  pageSize: 0,
  totalElements: 0,
  totalPages: 0
}

const state = {
  providerRates: [],
  pagination: { ...INITIAL_PAGINATION },
  partnersList: []
}

const mutations = {
  setProviderRates (state, value) {
    state.providerRates = value;
  },

  setPagination (state, value) {
    state.pagination = value;
  },

  setPartners (state, value) {
    state.partnersList = value;
  }
}

const getters = {
  providerRates: state => state.providerRates,
  providerRatesPagination: state => state.pagination,
  partnersList: state => state.partnersList
}

const actions = {
  createProviderRate (_, payload) {
    return ProviderRatesService.createProviderRate(payload);
  },

  deleteProviderRate (_, payload) {
    return ProviderRatesService.deleteProviderRate(payload);
  },

  updateProviderRate (_, payload) {
    return ProviderRatesService.updateProviderRate(payload);
  },

  async getProviderRates ({commit}, payload) {
    try {
      const { list, pagination } = await ProviderRatesService.getProviderRates(payload);
      commit("setProviderRates", list);
      commit("setPagination", pagination);
    } catch (error) {
      commit("setProviderRates", []);
      commit("setPagination", INITIAL_PAGINATION);
    }
  },

  async getPartners ({ commit }, payload) {
    const data = await ProviderRatesService.getPartners(payload);
    commit("setPartners", data);
    return data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
